import styled from "styled-components"
import backgroundImage from "../../images/nda/home-background.webp"
import backgroundOverlay from "../../images/overlay-dots.png"

const S = {}

S.HeroWrapper = styled.div`
  width: 100%;
  height: calc(100vh); //100px height of the TopMenu Component
  position: relative;

  & ::after {
    content: "";
    border-left: 150px solid transparent;
    border-right: 150px solid transparent;
    border-bottom: 100px solid #fff;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    transition: 0.5s;
    opacity: 1;
  }
`
S.HeroBackground = styled.div`
  width: 100vw;
  height: calc(98vh); //100px height of the TopMenu Component
  background-image: url(${backgroundImage});
  /* background-position: 0% 20%; */
  background-size: cover;
  position: relative;
  filter: brightness(0.3);

  @media (max-width: 768px) {
    background-position: 50% 0;
  }
`
S.HeroBackgroundOverlay = styled.div`
  width: 100vw;
  height: calc(98vh); //100px height of the TopMenu Component
  background-image: url(${backgroundOverlay});
  background-position: center;
  background-size: cover;
  position: relative;
`

S.TitleWrapper = styled.div`
  width: 1400px;
  margin: 0 auto;
  position: absolute;
  /* top: 315px; */
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 80vw;
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (min-width: 768px) {
    top: 215px;
    left: 20px
  }

  @media (min-width: 1366px) {
    top: 215px;
    left: 20px;
  }
  @media (min-width: 1440px) {
    top: 215px;
    left: 20px;
  }
  @media (min-width: 1680px) {
    top: 370px;
    left: 0;
  }
  @media (min-width: 1920px) {
    top: 400px;
    left: 0;
  }

  & .btn {
    text-decoration: none;
    border: none;
    position: relative;
    overflow: hidden;
    max-width: 380px;
    font-weight: 500;
    background: #dc8313f7;
    cursor: pointer;
    text-align: center;
    padding: 20px;

    & a {
      font-size: 18px;
      color: #fff;
      text-decoration: none;
      line-height: 28px;
      font-family: "Montserrat", sans-serif;
      font-weight: 700;
    }

    @media (max-width: 768px) {
      max-width: 100%;
    }

    & :hover {
      & ::before {
        left: 100%;
      }
    }

    & ::before {
      content: "";
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(120deg, transparent, #ffffff50, transparent);
      transition: all 650ms;
      animation: button-shining 6s infinite;
    }
  }
`

S.MainTitle = styled.h1`
  font-size: 48px;
  color: #efefef;
  text-shadow: 1px 1px #000;
  font-weight: 700;
  margin: 20px 0;
  @media (max-width: 768px) {
    font-size: 28px;
  }
  @media (min-width: 768px) {
    font-size: 36px;
  }
  @media (min-width: 1680px) {
    font-size: 48px;
  }
`

S.MainButton = styled.button`
  font-size: 18px;
  border-radius: 8px;
  padding: 12px 36px;
  color: #f4f4f4;
  text-transform: uppercase;
  max-width: 50%;
  margin-top: 50px;
`

S.ScrollDownButton = styled.a`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  color: #333;
  font: normal 100 18px/1 "Montserrat", sans-serif;
  letter-spacing: 0.5px;
  text-decoration: none;
  transition: opacity 0.5s;
  cursor: pointer;

  & :hover {
    opacity: 0.5;
  }

  & span {
    position: absolute;
    top: -310%;
    left: 50%;
    width: 18px;
    height: 18px;
    margin-left: -8px;
    border-left: 1px solid #333;
    border-bottom: 1px solid #333;
    transform: rotate(-45deg);
    animation: arrow-down 2s infinite;
    box-sizing: border-box;
  }

  @keyframes button-shining {
    0% {
      left: -100%;
    }
    45% {
      left: -100%;
    }
    55% {
      left: 100%;
    }
    65% {
      left: -100%;
    }
    100% {
      left: -100%;
    }
  }

  @keyframes arrow-down {
    0% {
      transform: rotate(-45deg) translate(0, 0);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: rotate(-45deg) translate(-20px, 20px);
      opacity: 0;
    }
  }
`

export default S
